import moment from "moment";
import { normalizeAOIBAN } from "utils/const";
export function userProfileEnterpriseUpdateMap(formData, file, userId) {
  if (formData != null && formData !== undefined) {
    const userColectiveTypeId = formData.userColectiveTypeId?.code ?? formData.userColectiveTypeId ?? null;
    const companyPropertyTypeId = formData.companyPropertyTypeId?.code ?? formData.companyPropertyTypeId ?? null;
    const isCooperative = Number(userColectiveTypeId) === 2;
    
    const data = new FormData();
    const user = {
      userType: 2,
      Name: formData.companyName ? formData.companyName : "",
      mobilePhone: formData.mobilePhone ? formData.mobilePhone : "",
      alternativeMobilePhone: formData.alternativeMobilePhone ? formData.alternativeMobilePhone : "",
      email: formData.email ? formData.email : "",
      Photo: file,
      id: userId,
    };
    const userColective = {
      userColectiveTypeId,
      contactName: formData.contactName ? formData.contactName : "",
      taxIdNumber: formData.taxIdNumber ? formData.taxIdNumber : "",
      permitCode: formData.permitCode ? formData.permitCode : "",
      permitCodeValidUntil: formData.permitCodeValidUntil
        ? moment(formData.permitCodeValidUntil).format("YYYY-MM-DD")
        : "",
      niss: formData.niss ? formData.niss : "",
      experience: !isCooperative && formData.experience ? formData.experience : 0,
      companyEmail: formData.companyEmail ? formData.companyEmail : "",
      companyPhone: formData.companyPhone ? formData.companyPhone : "",
      companyEACId: formData.companyEACId ? formData.companyEACId.code : 0,
      propertyType: formData.propertyType ?? "",
      IsStartupOrMicroenterprise: !isCooperative ? Boolean(formData.IsStartupOrMicroenterprise) : false,
      subsidiaryCompany: !isCooperative ? (formData.subsidiaryCompany ?? "") : "",
      subsidiaryCompanyPostalCode: !isCooperative ? (formData.subsidiaryCompanyPostalCode ?? "") : "",
      subsidiaryCompanyActivity: !isCooperative ? (formData.subsidiaryCompanyActivity ?? "") : "",
      subsidiaryCompanyEACId: !isCooperative ? (formData.subsidiaryCompanyEACId?.code) : null,
      maleWorkersNumber: formData.maleWorkersNumber ?? "",
      femaleWorkersNumber: formData.femaleWorkersNumber ?? "",
      totalWorkersNumber: formData.totalWorkersNumber ?? "",
      legalFormId: formData.legalFormId?.code,
      shareCapital: formData.shareCapital ?? "",
      publicDivisionPercentage: formData.publicDivisionPercentage ?? "",
      privateNationalDivisionPercentage: formData.privateNationalDivisionPercentage ?? "",
      activityStartYear: formData.activityStartYear ? moment(formData.activityStartYear).format("YYYY") : "",
      corporateObject: formData.corporateObject ?? "",
      companyActivityId: formData.companyActivityId,
      companyPropertyTypeId,
      bankAccountNumber: isCooperative ? normalizeAOIBAN(formData.bankAccountNumber ?? "") : "",
      disableWorkersNumber: isCooperative ? (formData.disableWorkersNumber ?? null) : null,
    };
    const compositeAddress = {
      provinceId: formData.province ? formData.province.code : 0,
      provinceKey: formData.province ? formData.province.keyValue : "",
      municipalityId: formData.municipality ? formData.municipality.code : 0,
      district: formData.district ? formData.district : "",
      address: formData.address ? formData.address : "",
    };
    //Append data
    for (const key in user) {
      if (key === "Photo" && !user[key]) continue;
      data.append("user." + key, user[key]);
    }

    for (const key in userColective) {
      data.append("user.userColective." + key, userColective[key]);
    }

    for (const key in compositeAddress) {
      data.append("user.userColective.compositeAddress." + key, compositeAddress[key]);
    }
    //Lists need to be treated seperately
    formData.businessPurpose?.forEach((element) => {
      data.append("user.userColective.businessPurposeList", element.code);
    });

    return data;
  }
  return formData;
}

export default userProfileEnterpriseUpdateMap;
